<template>
	<c-dialog ref="dialog" width="900" mode="slide" mask-close @close="dialogFormEditConfirm($refs.draffForm, arguments)">
		<c-tab-list ref="tabList" :tabs="tabList" :immediate="false" type="tab" @change="tabHandle"></c-tab-list>
		<!--生效中-->
		<div v-if="currentTab==1">
			<c-form ref="releaseForm" unit-width="100%">
				<c-title>
					绩效工资取数维度
				</c-title>
				<c-form-item :label="false">
					<c-table ref="releaseDimensionTable" :data="releaseDimensionTable" border :paging="false">
					<c-table-column type="drag" @handle="$emit('drag')"></c-table-column>
					<c-table-column label="序号" width="35" name="index"></c-table-column>
						<c-table-column label="业务对象" width="100" name="work_type_name"></c-table-column>
						<c-table-column label="属性" width="100" name="field_title"></c-table-column>
					</c-table>
				</c-form-item>
			</c-form>
		</div>
		<!--草稿-->
		<div v-if="currentTab==0">
			<c-form ref="draffForm" unit-width="100%">
				<c-title>
					绩效工资取数维度
				</c-title>
				<c-form-item :label="false">
					<m-operate border>
						<c-button color="main" prepend-icon="tf-add" @click="dimensionSelector()">添加绩效工资取数维度</c-button>
					</m-operate>
					<c-table ref="draffDimensionTable" :data="draffDimensionList" border :paging="false">
						<c-table-column type="drag" @handle="$emit('drag')"></c-table-column>
						<c-table-column label="序号" width="30" name="index"></c-table-column>
						<c-table-column label="业务对象" width="80" name="work_type_name"></c-table-column>
						<c-table-column label="属性" width="100" name="field_title"></c-table-column>
						<c-table-column type="button" label="操作" width="80">
							<template #default="{data}">
								<c-table-button icon="tf-trash" @click="removeRow(1,data)">删除</c-table-button>
							</template>
						</c-table-column>
					</c-table>
				</c-form-item>
			</c-form>
		</div>

		<template #button>
			<c-button v-if="currentTab == 0" color="main" size="dialog" @click="submit(1)">保存</c-button>
			<c-button v-if="currentTab == 0" size="dialog" @click="submit(2)">生效</c-button>
			<c-button v-if="currentTab == 0" size="dialog" @click="$refs.dialog.close()">取消</c-button>
			<c-button v-if="currentTab == 1 && releaseDimensionTable && releaseDimensionTable.length > 0"
                color="main" size="dialog" @click="saveSortConfig()">保存排序</c-button>
		</template>

		<c-dialog ref="groupDimensionDialog" title="新增绩效工资维度组合" width="600" height="400" enable-flex @resolve="resolveNewGroup">
			<c-table ref="groupDimensionTable" :data="draffDimensionList" height="grow" border :paging="false">
				<c-table-column type="selector" width="32"></c-table-column>
				<c-table-column label="序号" width="35" name="index"></c-table-column>
				<c-table-column label="业务对象" width="120" name="work_type_name"></c-table-column>
				<c-table-column label="属性" width="150" name="field_title"></c-table-column>
			</c-table>
		</c-dialog>
	</c-dialog>
</template>

<script>
import {mapState} from "vuex";
//选择绩效工资维度
export default {
	name: 'salary_rule_config',
	components: {},
	computed: {
		// 获取dictName选项数据
		...mapState(['productTypeName']),
		tabList() {
			let list = [];
			list.push({"value":1, "name": "生效中"});
			list.push({"value":0,"name": "草稿"});
			return list;
		}
	},
	// 监听器
	watch: {
	},
	mounted() {
	},
	data() {
		return {
			currentTab:0,                   //0:草稿  1：生效中
			tabArr:[],                      //已经请求的数据集合
			releaseDimensionTable:[],       //已发布维度数据集合
			releaseGroupTable:[],           //已发布 绩效工资维度组合
			draffDimensionList:[],          //草稿维度数据集合
			draffGroupList:[]              //草稿 绩效工资维度组合
		}
	},
	methods: {
		/************打开新增、编辑弹窗**************/
		open() {
			this.$refs.draffForm && this.$refs.draffForm.setEditState(false);
			this.tabArr = [];
			this.$refs.tabList.changeIndex(0);//选中第一项
			//填充form表单
			this.$refs.dialog.open({
				title:'绩效工资匹配规则管理'
			});
		},

		/********切换Tab***********/
		tabHandle(tab) {
			this.currentTab = tab.value;
			this.templateList = [];
			if (!this.tabArr.includes(this.currentTab)){
				this.loadRuleDetail(this.currentTab);
				this.tabArr.push(this.currentTab);
			}
		},

		/*******删除行数据*****************/
		removeRow(type,data){
			this.$refs.draffForm.setEditState(true);
			if (type == 1){//维度数据
				// 确认弹窗
				this.$confirm({
					title: '删除警告',
					message: '确认删除维度属性【'+data.field_title+'】？操作将同时删除关联的绩效维度组合',
					resolve: () => {
						this.draffDimensionList = this.draffDimensionList.filter(function(item) {
							return item.field_id !== data.field_id;
						});
						this.draffDimensionList = this.resortList(this.draffDimensionList);
						//删除维度的同时，删除包含该维度的组合信息
						this.draffGroupList = this.draffGroupList.filter(function(item) {
							return !item.field_ids.includes(data.field_id);
						});
						this.draffGroupList = this.resortList(this.draffGroupList);
					},
					cancel: () => {}
				})
			}else {//组合数据
				this.draffGroupList = this.draffGroupList.filter(function(item) {
					return item.index !== data.index;
				});
				this.draffGroupList = this.resortList(this.draffGroupList);
			}
		},

		/*******查询【规则】详情信息*****************/
		loadRuleDetail(state){
			this.request({
				url:'/salary/match/rule/detail',
				data: {
					state:state
				},
				success:data => {
					if (data){
						var count = 1;
						var groupCount = 1;
						if (state == 1){
							this.releaseDimensionTable = (data.dimension_config_list||[]).map(item => {
								item.index = count++;
								return item;
							});
							this.releaseGroupTable = (data.dimension_group_list||[]).map(item => {
								item.index = groupCount++;
								return item;
							});
						}else {
							this.draffDimensionList = (data.dimension_config_list||[]).map(item => {
								item.index = count++;
								return item;
							});
							this.draffGroupList = (data.dimension_group_list||[]).map(item => {
								item.index = groupCount++;
								return item;
							});
						}
					}
				}
			})
		},

		/****************添加新维度***********************/
		dimensionSelector() {
			var exclude_dimension_ids = [];
			if (this.draffDimensionList && this.draffDimensionList.length > 0){
				exclude_dimension_ids = this.draffDimensionList.map(item => {
					return item.field_id;
				});
			}
			this.globalDialog('salaryDimensionSelector',{
				props: {
					multiple: true
				},
				data:{
					exclude_dimension_ids:exclude_dimension_ids
				}
			}, this.draffDimensionListAddHandle);
		},

		/*************添加新维度-响应方法***************/
		draffDimensionListAddHandle(rows){
			if (rows && rows.length > 0) {
				this.$refs.draffForm.setEditState(true);
				rows.map(item => {
					var obj = item.data;
					obj.index = this.draffDimensionList.length + 1;
					this.draffDimensionList.push(obj);
				});
			}else {
				this.$message({
					message: '请选择取数维度'
				});
				return false;
			}
		},

		/***************新增组合**************************/
		resolveNewGroup(stop){
			var selectedRows = this.$refs.groupDimensionTable.getRow('selected');
			if (!selectedRows || selectedRows.length == 0){
				this.$message({
					message: '请选择取数维度'
				});
				stop();
				return ;
			}
			var fieldIdList = selectedRows.map(item => {
				console.log(item.data);
				return item.data.field_id;
			});
			var field_names = selectedRows.map(item => {
				return item.data.field_title;
			}).join(",");
			if (this.checkGroupExists(fieldIdList)){
				this.$message({
					message: '该绩效维度组合【'+field_names+'】已存在，请勿重复添加'
				});
				stop();
				return ;
			}
			var newGroup = {};
			newGroup.field_ids = fieldIdList;
			newGroup.field_names = field_names;
			newGroup.index = this.draffGroupList.length + 1;
			this.draffGroupList.push(newGroup);
			this.$refs.draffForm.setEditState(true);
		},

		/********************判断当前组合是否存在，已存在则报错**************************/
		checkGroupExists(fieldIdList){
			var flag = false;//true = 表示组合已存在
			this.draffGroupList.forEach(item => {
				if (item.field_ids && item.field_ids.length > 0){
					var field_ids = item.field_ids||[];
					console.log(field_ids);
					if(field_ids.length === fieldIdList.length && JSON.stringify(field_ids.sort()) == JSON.stringify(fieldIdList.sort())){
						flag = true;
					}
				}
			});
			return flag;
		},

		/********************排序**************************/
		sortHandle(row, type, next) {
			next();
			this.$refs.draffForm.setEditState(true);
			var data = this.$refs.draffGroupTable.getData();
			this.draffGroupList = this.resortList(data);
		},

		/******************列表排序***************************/
		resortList(list){
			var count = 1;
			list.forEach(item => {
				item.index = count ++ ;
			});
			return list;
		},

		/**
		 * 提交数据
		 * type = 1 : 保存
		 * type = 2 : 保存并发布
		 */
		submit(type){
			var draff_dimension_list = this.$refs.draffDimensionTable.getData();
			if (!draff_dimension_list || draff_dimension_list.length==0){
				this.$message({
					message:'至少添加一个绩效工资取数维度',  // 提示内容,
					type: 'warn'
				});
				return;
			}
			this.request({
				url: '/salary/match/rule/edit',
				data: {
					dimension_config_list:draff_dimension_list,
					dimension_group_list: this.draffGroupList
				},
				loading: {
					message: '数据提交中...'
				},
				success: data => {
					if (type == 2){//发布
						// 确认弹窗
						this.$confirm({
							title: '确定生效',
							message: '绩效工资匹配规则的修改，可能导致已存在的绩效工资配置配置信息失效，建议重新修改绩效工资配置数据',
							buttonName: '确定生效',
							cancelButtonName: '暂不生效',
							resolve: () => {
								this.request({
									url: '/salary/match/rule/release',
									data: {},
									success: data => {
										this.$message({
											message:'草稿生效成功',  // 提示内容,
											type: 'success'
										});
										//刷新列表生效数据列表
										this.loadRuleDetail(1);
										this.$refs.dialog.close();
										this.$bus.$emit('salary_match_config.field.update', {});//更新表头
										this.$bus.$emit('salary_match_config.list.update', {});//更新数据
									}
								});
							},
							cancel: () => {
								this.$message({
									message:'草稿生效已取消（草稿已保存）',  // 提示内容,
									type: 'success'
								});
							}
						});
					}else {
						this.$message({
							message:'保存成功',  // 提示内容,
							type: 'success'
						});
					}
					this.$refs.draffForm.setEditState(false);
				},
				fail: () => {
				}
			});
		},
		
		/**
     * 保存排序
		 */
		saveSortConfig() {
			var dimension_config_list = this.$refs.releaseDimensionTable.getData();
			this.request({
				url: '/salary/match/rule/dimension/sort',
				data: {
					dimension_config_list:dimension_config_list
				},
				success: data => {
				  this.$message({
					  message:'排序数据保存成功',  // 提示内容,
					  type: 'success'
				  });
				  this.$bus.$emit('salary_match_config.field.update', {});//更新表头
				  this.$bus.$emit('salary_match_config.list.update', {});//更新数据
				}
			});
		},
		
		/**
		 * 清空绩效工资配置规则
		 * type = 1 : 保存
		 * type = 2 : 保存并发布
		 */
		clear() {
			// 确认弹窗
			this.$confirm({
				title: '清空绩效工资配置',
				message: '确认后将导出当前配置，并清空绩效工资配置。数据清空后无法恢复，请谨慎操作',
				resolve: () => {
					this.$message({
						message:'清空绩效工资配置成功',  // 提示内容,
						type: 'success'
					});
				},
				cancel: () => {
				}
			});
		}
	}
}
</script>
<style lang="stylus" scoped>
</style>